document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Judge.me carousel: click review to show full text ----------
     Trying to un-clamp the card in place (an earlier version of this)
     broke Judge.me's slider (Slick), which pre-computes a shared
     height/position for every slide at init — overriding one card's
     height desynced that and cards overlapped. So instead: read the
     review's data straight out of the (always-complete, only visually
     clamped) DOM and show it in our own modal, appended to <body>,
     completely outside the carousel's layout.
     Judge.me's slider also binds its own click handler on each slide and
     calls stopPropagation() on it to swallow clicks it thinks are part
     of a drag. Binding on `document` with capture:true runs our handler
     before that happens, regardless of what Judge.me does with the event
     afterwards. */
  var reviewModal = null;

  function buildReviewModal() {
    var modal = document.createElement('div');
    modal.className = 'testi-review-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="testi-review-modal__backdrop" data-modal-close></div>' +
      '<div class="testi-review-modal__card" role="dialog" aria-modal="true">' +
        '<button type="button" class="testi-review-modal__close" data-modal-close aria-label="Schließen">✕</button>' +
        '<div class="testi-review-modal__stars"></div>' +
        '<div class="testi-review-modal__title"></div>' +
        '<p class="testi-review-modal__body"></p>' +
        '<div class="testi-review-modal__footer">' +
          '<img class="testi-review-modal__product-img" alt="">' +
          '<div class="testi-review-modal__meta"><span></span><small></small></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close]')) closeReviewModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeReviewModal();
    });
    return modal;
  }

  function closeReviewModal() {
    if (reviewModal) reviewModal.hidden = true;
  }

  function openReviewModal(item) {
    if (!reviewModal) reviewModal = buildReviewModal();

    var starCount = item.querySelectorAll('.jdgm-carousel-item__review-rating .jdgm--on').length;
    var title = item.querySelector('.jdgm-carousel-item__review-title');
    var body = item.querySelector('.jdgm-carousel-item__review-body');
    var name = item.querySelector('.jdgm-carousel-item__reviewer-name');
    var date = item.querySelector('.jdgm-carousel-item__timestamp');
    var productImg = item.querySelector('.jdgm-carousel-item__product-image');

    reviewModal.querySelector('.testi-review-modal__stars').textContent =
      '★'.repeat(starCount) + '☆'.repeat(5 - starCount);
    var titleEl = reviewModal.querySelector('.testi-review-modal__title');
    var titleText = title ? title.textContent.trim() : '';
    titleEl.textContent = titleText;
    titleEl.style.display = titleText ? '' : 'none';
    reviewModal.querySelector('.testi-review-modal__body').textContent = body ? body.textContent.trim() : '';

    var imgEl = reviewModal.querySelector('.testi-review-modal__product-img');
    if (productImg && productImg.src) {
      imgEl.src = productImg.src;
      imgEl.alt = productImg.alt || '';
      imgEl.style.display = '';
    } else {
      imgEl.style.display = 'none';
    }
    reviewModal.querySelector('.testi-review-modal__meta span').textContent = name ? name.textContent.trim() : '';
    reviewModal.querySelector('.testi-review-modal__meta small').textContent = date ? date.textContent.trim() : '';

    reviewModal.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var carousel = e.target.closest('.testi-carousel');
    if (!carousel) return;
    var item = e.target.closest('.jdgm-carousel-item');
    if (!item) return;
    openReviewModal(item);
  }, true);

  /* ---------- Product / bestseller tabs ---------- */
  document.querySelectorAll('[data-tabbar]').forEach(function (bar) {
    var section = bar.closest('[data-tab-section]');
    if (!section) return;
    bar.querySelectorAll('button[data-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        bar.querySelectorAll('button[data-tab]').forEach(function (b) { b.classList.remove('active'); });
        section.querySelectorAll('.panel').forEach(function (p) { p.classList.remove('active'); });
        btn.classList.add('active');
        var panel = section.querySelector('#panel-' + btn.dataset.tab);
        if (panel) panel.classList.add('active');
      });
    });
  });

  /* ---------- Mobile nav drawer ---------- */
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileDrawer = document.querySelector('[data-mobile-drawer]');
  var mobileClose = document.querySelector('[data-mobile-drawer-close]');
  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', function () { mobileDrawer.classList.add('is-open'); });
  }
  if (mobileClose && mobileDrawer) {
    mobileClose.addEventListener('click', function () { mobileDrawer.classList.remove('is-open'); });
  }
  if (mobileDrawer) {
    mobileDrawer.addEventListener('click', function (e) {
      if (e.target === mobileDrawer) mobileDrawer.classList.remove('is-open');
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart() { if (cartDrawer) cartDrawer.classList.add('is-open'); }
  function closeCart() { if (cartDrawer) cartDrawer.classList.remove('is-open'); }

  cartOpeners.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  cartClosers.forEach(function (el) {
    el.addEventListener('click', closeCart);
  });

  /* Refresh cart drawer contents via Shopify's Cart AJAX API */
  function refreshCartDrawer() {
    if (!cartDrawer) return;
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-inner]');
        var current = cartDrawer.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          bindCartDrawerEvents();
        }
      })
      .catch(function () { /* fail silently in preview contexts */ });
  }

  function bindCartDrawerEvents() {
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeCart);
    });
    cartDrawer.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeLineQty(btn, -1); });
    });
    cartDrawer.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeLineQty(btn, 1); });
    });
  }

  function changeLineQty(btn, delta) {
    var row = btn.closest('[data-line-key]');
    if (!row) return;
    var key = row.dataset.lineKey;
    var input = row.querySelector('input[type="number"], input[data-qty-input]');
    var qty = Math.max(0, parseInt((input && input.value) || '1', 10) + delta);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { refreshCartDrawer(); })
      .catch(function () {});
  }

  /* Intercept "add to cart" forms to use AJAX + open drawer */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () {
          refreshCartDrawer();
          openCart();
        })
        .catch(function () {});
    });
  });

  bindCartDrawerEvents();

  /* ---------- Simple variant option -> hidden select sync ---------- */
  document.querySelectorAll('[data-variant-options]').forEach(function (wrap) {
    var form = wrap.closest('form');
    var select = form ? form.querySelector('select[data-variant-select]') : null;
    wrap.querySelectorAll('button[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        wrap.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (select) {
          select.value = btn.dataset.variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (btn.dataset.image) {
          var mainImg = document.getElementById('main-product-image');
          if (mainImg) mainImg.src = btn.dataset.image;
        }
      });
    });
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-step-minus]');
    var plus = stepper.querySelector('[data-step-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- Header search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.hidden = !searchPanel.hidden;
      if (!searchPanel.hidden) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Sync price / unit price / availability with selected variant ---------- */
  document.querySelectorAll('select[data-variant-select]').forEach(function (select) {
    function syncFromOption() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;

      var priceEl = document.getElementById('product-price');
      var compareEl = document.getElementById('product-compare');
      var unitPriceEl = document.getElementById('product-unit-price');
      var unitRow = document.getElementById('product-unit-row');
      var addBtn = document.getElementById('add-to-cart-btn');

      if (priceEl) {
        priceEl.textContent = opt.dataset.price || '';
        priceEl.classList.toggle('on-sale', !!opt.dataset.comparePrice);
      }
      if (compareEl) {
        if (opt.dataset.comparePrice) {
          compareEl.textContent = opt.dataset.comparePrice;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (unitPriceEl && unitRow) {
        if (opt.dataset.unitPrice) {
          unitPriceEl.textContent = opt.dataset.unitPrice;
          unitRow.style.display = '';
        } else {
          unitRow.style.display = 'none';
        }
      }
      if (addBtn) {
        var available = opt.dataset.available === 'true';
        addBtn.disabled = !available;
        addBtn.textContent = available
          ? (addBtn.dataset.availableLabel || addBtn.textContent)
          : (addBtn.dataset.soldOutLabel || 'Ausverkauft');
      }
    }
    select.addEventListener('change', syncFromOption);
  });

  /* ---------- Recipe: live servings scaler ---------- */
  function formatRecipeAmount(n) {
    var rounded = Math.round(n * 100) / 100;
    var str = rounded % 1 === 0 ? String(rounded) : rounded.toFixed(2).replace(/0$/, '').replace(/0$/, '').replace(/\.$/, '');
    return str.replace('.', ',');
  }
  document.querySelectorAll('[data-recipe-servings]').forEach(function (stepper) {
    var wrap = stepper.closest('.recipe-ingredients-col') || document;
    var list = wrap.querySelector('.ingredient-list');
    if (!list) return;
    var baseServings = parseFloat(list.dataset.baseServings) || 1;
    var input = stepper.querySelector('input');
    var display = document.getElementById('servings-display');

    function update() {
      var current = parseInt(input.value, 10) || baseServings;
      list.querySelectorAll('.ingredient-item').forEach(function (item) {
        var base = parseFloat(item.dataset.amount);
        var out = item.querySelector('.amount-value');
        if (!isNaN(base) && out) {
          out.textContent = formatRecipeAmount((base * current) / baseServings);
        }
      });
      if (display) display.textContent = current;
    }

    var minus = stepper.querySelector('[data-step-minus]');
    var plus = stepper.querySelector('[data-step-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || baseServings) - 1);
      update();
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || baseServings) + 1;
      update();
    });
  });

  /* ---------- Recipe: add linked ingredient straight to cart ---------- */
  document.querySelectorAll('.ingredient-cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function () {
          refreshCartDrawer();
          openCart();
        })
        .catch(function () {});
    });
  });

  /* ---------- Combine multiple tag filters (collections & blog) ---------- */
  document.querySelectorAll('[data-tag-filter]').forEach(function (group) {
    var baseUrl = group.dataset.collectionUrl;
    var taggedPath = group.dataset.taggedPath || '/';
    var applyBtn = group.querySelector('[data-filter-apply]');
    if (!applyBtn) return;
    applyBtn.addEventListener('click', function () {
      var checkboxes = group.querySelectorAll('input[type="checkbox"][data-tag]');
      var activeTags = [];
      checkboxes.forEach(function (c) {
        if (c.checked) activeTags.push(c.dataset.tag);
      });
      var url = baseUrl;
      if (activeTags.length > 0) {
        url += taggedPath + activeTags.join('+');
      }
      window.location.href = url;
    });
  });

  /* ---------- Scroll to top button ---------- */
  var scrollTopBtn = document.querySelector('[data-scroll-top]');
  if (scrollTopBtn) {
    var toggleScrollTopBtn = function () {
      if (window.scrollY > 500) {
        scrollTopBtn.classList.add('is-visible');
      } else {
        scrollTopBtn.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', toggleScrollTopBtn, { passive: true });
    toggleScrollTopBtn();
    scrollTopBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- Mobile filter drawer (collection & blog) ---------- */
  document.querySelectorAll('[data-mobile-filter-toggle]').forEach(function (btn) {
    var wrap = btn.closest('.collection-layout');
    if (!wrap) return;
    var aside = wrap.querySelector('[data-filter-aside]');
    var overlay = wrap.querySelector('[data-mobile-filter-overlay]');
    var closeBtn = wrap.querySelector('[data-mobile-filter-close]');

    function openFilter() {
      if (aside) aside.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    }
    function closeFilter() {
      if (aside) aside.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
    }

    btn.addEventListener('click', openFilter);
    if (closeBtn) closeBtn.addEventListener('click', closeFilter);
    if (overlay) overlay.addEventListener('click', closeFilter);
  });

  /* ---------- Announcement / topbar dismiss (optional) ---------- */
  var topbarClose = document.querySelector('[data-topbar-close]');
  if (topbarClose) {
    topbarClose.addEventListener('click', function () {
      topbarClose.closest('.topbar').style.display = 'none';
    });
  }
});
